import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf"; // For generating PDFs if needed
import "./Newspaper.css";  // Make sure to include the corresponding CSS file

const Newspaper = () => {
  const [month, setMonth] = useState("");  // Store month
  const [day, setDay] = useState("");      // Store day
  const [year, setYear] = useState("");    // Store year
  const [pageImages, setPageImages] = useState([]);  // Store images as base64
  const [loading, setLoading] = useState(false);

  const base_url = "https://khanehyeghtesad.com:8000";  // Replace with your base URL
  const navigate = useNavigate();  // To navigate to login if not authenticated

  // Function to handle file input change
  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];  // Get base64 string without prefix
        const newPageImages = [...pageImages];
        newPageImages[index] = base64String;  // Set base64 for the specific page
        setPageImages(newPageImages);  // Update page images
      };
      reader.readAsDataURL(file);  // Convert the file to base64
    }
  };

  // Function to handle the form submission
const handleSubmit = async (e) => {
  e.preventDefault();

  // Ensure the date is complete and images are uploaded
  if (!year || !month || !day || pageImages.length < 8) {
    alert("Please provide the full date and all 8 images");
    return;
  }

  // Pad the month and day with leading zeros if needed
  const paddedMonth = month.padStart(2, "0");  // Ensures two digits for the month
  const paddedDay = day.padStart(2, "0");      // Ensures two digits for the day

  const shamsiDate = `${year}${paddedMonth}${paddedDay}`; // Combine the year, padded month, and padded day into a single shamsi date string

  // Check if the user is authenticated
  const accessToken = localStorage.getItem("access");
  if (!accessToken) {
    navigate("/admin/login"); // Redirect to login page if no access token
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post(
      `${base_url}/api/newspaper/new/`,
      {
        shamsi_date: parseInt(shamsiDate),
        page1: pageImages[0],
        page2: pageImages[1],
        page3: pageImages[2],
        page4: pageImages[3],
        page5: pageImages[4],
        page6: pageImages[5],
        page7: pageImages[6],
        page8: pageImages[7],
      },
      {
        headers: { Authorization: `Bearer ${accessToken}` }, // Include the token in the headers
      }
    );

    console.log("Newspaper uploaded successfully:", response.data);
    alert("Newspaper uploaded successfully!");
    // Reset the form after successful submission
    setYear("");
    setMonth("");
    setDay("");
    setPageImages([]);
  } catch (error) {
    console.error("Error uploading newspaper:", error);
    alert("Error uploading newspaper.");
  }

  setLoading(false);
};


  return (
    <div className="newspaper-page">
      <header className="newspaper-header">
        <h1>آپلود روزنامه</h1>
      </header>

      <form onSubmit={handleSubmit} className="newspaper-form">
        <div className="date-input">
          <label>تاریخ شمسى:</label>
          <div className="date-selectors">
            {/* Year Dropdown */}
            <select value={year} onChange={(e) => setYear(e.target.value)} required>
              <option value="">سال</option>
              <option value="1403">1403</option>
              <option value="1404">1404</option>
              {/* Add more years as needed */}
            </select>

            {/* Month Dropdown */}
            <select value={month} onChange={(e) => setMonth(e.target.value)} required>
              <option value="">ماه</option>
              <option value="01">فروردین</option>
              <option value="02">اردیبهشت</option>
              <option value="03">خرداد</option>
              <option value="04">تیر</option>
              <option value="05">مرداد</option>
              <option value="06">شهریور</option>
              <option value="07">مهر</option>
              <option value="08">آبان</option>
              <option value="09">آذر</option>
              <option value="10">دی</option>
              <option value="11">بهمن</option>
              <option value="12">اسفند</option>
            </select>

            {/* Day Dropdown */}
            <select value={day} onChange={(e) => setDay(e.target.value)} required>
              <option value="">روز</option>
              {Array.from({ length: 31 }, (_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="image-inputs">
          <label>بارگذاری صفحات روزنامه</label>
          {Array.from({ length: 8 }, (_, i) => (
            <div key={i} className="image-upload">
              <label>صفحه {i + 1}:</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, i)}
                required
              />
            </div>
          ))}
        </div>

        <button type="submit" disabled={loading} className="upload-btn">
          {loading ? "در حال بارگذاری..." : "آپلود روزنامه"}
        </button>
      </form>
    </div>
  );
};

export default Newspaper;
